import { BaseModel } from 'app/core/_base/crud';

    
    
        
    
        
            
            
    export class PhongHopModel extends BaseModel {
            Id_Phong : number;
            TenPhong : string;
            MoTa : string;
            NguoiTao : string;
            TenNguoiTao : string;
            ViTri : number;
        clear() {
                this.Id_Phong = 0;
                this.TenPhong = '';
                this.MoTa = '';
                this.NguoiTao = '';
                this.TenNguoiTao = '';
                this.ViTri = 1;
        }
    
        copy(item:PhongHopModel){
            
                this.Id_Phong = item.Id_Phong;
            
                this.TenPhong = item.TenPhong;
            
                this.MoTa = item.MoTa;
            
                this.NguoiTao = item.NguoiTao;
            
                this.TenNguoiTao = item.TenNguoiTao;
                this.ViTri = item.ViTri;
            
        }
    
    }
